// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';
import {seperateLeadAccountsByTerritory} from '../../../user/shared/services/tcsm-territories-helper';
const basePath = '/api';

export const getTerritories = async (racfId, tabm) => {

    const endPoint = `${basePath}/users/${racfId}/dealer-hierarchy?tabm=${tabm}`;

    try {

        const response = await fetchService.fetch(endPoint);

        const territoryArray = await response.json();

        return seperateLeadAccountsByTerritory(territoryArray);

    } catch (response) {

        return handleError(response);

    }

};



// WEBPACK FOOTER //
// ./src/tabm/shared/repositories/territories.js